export const useStyles = (theme) => ({
  paper: { padding: 20 },
  body: {
    display: "flex",
    minHeight: "20vh",
    alignItems: "center",
    justifyContent: "center",
  },
});
